import { render } from "./Piechart.vue?vue&type=template&id=b0ec6576"
import script from "./Piechart.vue?vue&type=script&lang=js"
export * from "./Piechart.vue?vue&type=script&lang=js"

import "./Piechart.vue?vue&type=style&index=0&id=b0ec6576&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__